import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgDocFlatDownload(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M90.571 17.625c6.312 0 11.429 5.117 11.429 11.429H44.857c0-6.312-5.117-11.429-11.428-11.429H90.57Z"
        fill="#E2E8F0"
      />
      <path
        d="M33.429 17.625C27.117 17.625 22 22.742 22 29.054v68.571h57.143V29.054c0-6.312 5.117-11.429 11.428-11.429H33.43Z"
        fill="#F1F5F9"
      />
      <path
        d="M78.343 29.054c0-6.754 5.475-12.229 12.228-12.229a.8.8 0 1 1 0 1.6c-5.87 0-10.628 4.759-10.628 10.629a.8.8 0 1 1-1.6 0Z"
        fill="#0F172A"
      />
      <path
        d="M37.96 36.061a2.508 2.508 0 0 0-3.319.768l-.09.143a3.747 3.747 0 0 0-.011.02l-4.004 6.888-.117.228a2.484 2.484 0 0 0 1.032 3.175c1.192.684 2.72.28 3.411-.91l1.853-3.187 1.851 3.187a2.505 2.505 0 0 0 3.411.91 2.483 2.483 0 0 0 .915-3.403l-4.003-6.887-.012-.02-.09-.143a2.486 2.486 0 0 0-.826-.769Zm3.549 8.623a.883.883 0 0 1-.328 1.211.904.904 0 0 1-1.23-.326l-2.31-3.976 1.036-1.783 2.832 4.874Zm-5.72-3.09-2.31 3.975a.904.904 0 0 1-1.231.326.883.883 0 0 1-.328-1.21l2.833-4.875 1.036 1.783Zm.474-4.143a.906.906 0 0 1 .902-.001.887.887 0 0 1 .329 1.21l-.78 1.342-.78-1.341a.88.88 0 0 1 .001-.886v-.001a.885.885 0 0 1 .328-.323Z"
        fill="#78B441"
      />
      <path
        d="M31 76.872a.8.8 0 0 0 0 1.601h40a.8.8 0 0 0 0-1.6H31Zm0-5.713a.8.8 0 1 0 0 1.6h40a.8.8 0 1 0 0-1.6H31Zm0-5.715a.8.8 0 0 0 0 1.6h40a.8.8 0 0 0 0-1.6H31Zm0-5.714a.8.8 0 1 0 0 1.6h40a.8.8 0 1 0 0-1.6H31Zm0-5.714a.8.8 0 1 0 0 1.6h40a.8.8 0 0 0 0-1.6H31ZM48.143 48.3a.8.8 0 0 0 0 1.6H71a.8.8 0 1 0 0-1.6H48.143Zm0-5.714a.8.8 0 0 0 0 1.6H71a.8.8 0 1 0 0-1.6H48.143Zm0-5.715a.8.8 0 0 0 0 1.601H71a.8.8 0 0 0 0-1.6H48.143Zm0-5.713a.8.8 0 0 0 0 1.6H71a.8.8 0 1 0 0-1.6H48.143Z"
        fill="#B3C0D0"
      />
      <path
        d="m42.31 96.063 7.949 7.281c.41.375 1.073.375 1.482 0l7.95-7.281c.66-.605.193-1.639-.741-1.639h-2.71v-3.84c0-.53-.47-.959-1.048-.959h-8.384c-.579 0-1.048.43-1.048.96v3.84h-2.71c-.934 0-1.401 1.033-.74 1.638Z"
        fill="#78B441"
      />
    </svg>
  )
}
export default wrapIllustration(SvgDocFlatDownload)
